module.exports = __webpack_public_path__ + "static/media/btn_eli.fc3e0848.png";